
import {
    defineComponent,
    onMounted,
    ref,
    inject,
    provide
} from 'vue'

import type {
    UploadInstance,
    UploadProps,
} from "element-plus";

import VisorFile from "@/components/modals/general/VisorFile.vue"

//services
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import fileService from "@/core/services/FileService";
//import acrdService from "@/core/services/AcrdService";
import JwtService from "@/core/services/JwtService";
import { errManager, mbtoa, showNotification, showMessage, validFormatImgPDF } from "@/core/config/Tools"
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "s-files",
    props: {
        idacrd: {
            type: String,
            required: true,
            default: ""
        },
        target: {
            type: String,
            required: true,
            default: 'payroll'
        }
    },
    components: { VisorFile },
    setup(props) {
        //const url = ref(process.env.VUE_APP_REPO);
        const { t } = useI18n();
        const urlUpload = ref(process.env.VUE_APP_API_URL)
        const listTypeFile = inject<any>('listTypeFile')
        const loading = ref(false)
        const listFiles = ref<any[]>([])
        const alias = ref('')
        const upload = ref<UploadInstance>()
        const headers = ref({
            Authorization: `Bearer ${JwtService.getToken()}`
        })
        const dataUpload = ref({
            target: props.target,
            alias: alias.value,
            id: mbtoa(props.idacrd)
        })
        //variables to visor
        const open_dialog_view_file = ref(false)
        const urlFile = ref('')
        const filesUploads = inject<any>("filesUploads")
        provide("urlFile", urlFile)
        provide("open_dialog_view_file", open_dialog_view_file)

        const getFiles = async () => {
            if(props.idacrd){
                loading.value = true
                listFiles.value = []
                await fileService.getFiles(mbtoa(props.idacrd), props.target)
                    .then((res) => {
                        listFiles.value = res.data
                        loading.value = false
                    }).catch(({ response }) => {
                        loading.value = false
                        errManager(response)
                    })
            }
        }

        const beforeUpload: UploadProps['beforeUpload'] = (rawFile) => {
            if(alias.value == ''){
                showMessage({title: process.env.VUE_APP_NAME, message: '¡Falta seleccionar el tipo de archivo que desea subir!', status: 'error' })   
                return false
            }

            if (!validFormatImgPDF(rawFile.type)) {
                showMessage({title: '', message: '¡El archivo seleccionado debe ser en formato indicado!', status: 'error' })   
                return false
            } else if (rawFile.size > (500 * 1024)) {
                showMessage({title: '', message: '!El archivo seleccionado supera los tamaño indicado!', status: 'error' })
                return false
            }
            dataUpload.value.alias = alias.value 
            return true
        };

        const handleError: UploadProps['onError'] = (error: Error, uploadFile) => {
            const e = JSON.parse(error.message);
            Swal.fire({
                title: `Error [${e.status}]`,
                text: e.messages.error,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Intentar otra vez!",
                customClass: {
                        confirmButton: "btn fw-bold btn-light-danger",
                },
            });
        }

        const handleSuccess: UploadProps['onSuccess'] = (response, uploadFile) => {
            alias.value = ''
            upload.value!.handleRemove(uploadFile)
            showNotification(response)
            if(response.id)
                filesUploads.value.push(response.id)
            getFiles()
        }

        const openVisorFile = (ruta) => {
            urlFile.value = `${ruta}`
            open_dialog_view_file.value = true
        }

        onMounted(() => {
            /*if(listTypeFile.value.length == 1){
                alias.value = listTypeFile.value[0].id
            }
            */
            getFiles()
        })

        return {
            t,
            loading,
            listTypeFile,
            alias,
            listFiles,
            mbtoa,
            //file upload
            upload,
            dataUpload,
            headers,
            urlUpload,

            //events
            getFiles,
            beforeUpload,
            handleError,
            handleSuccess,
            openVisorFile
        }
    },
})
